@if (!isForm) {
  <div class="modal-content">
    @if (img) {
      <img class="icon-styling mb-2" [src]="img" aria-hidden="true" />
    }
    @if (title && !isHTML) {
      <div class="confirmation-message">
        <span style="margin: 1rem" class="modal-title-style">{{ title }} </span>
      </div>
    }
    @if (showCloseButton) {
      <button type="button" class="close" (click)="onButtonClick('cancel')">
        <span> &times; </span>
      </button>
    }
    <div class="modal-body">
      @if (!isHTML) {
        @if (description) {
          <div class="confirmation-message">
            <span class="modal-description-style" style="margin: 1rem"
              >{{ description }}
            </span>
          </div>
        }
      }
      @if (isHTML && description && title) {
        <div class="py-0 modal-box">
          <div class="confirmation-message">
            <span class="modal-title-style dark-blue-theme title-box">{{ title }} </span>
          </div>
          <div class="confirmation-message">
            <span class="modal-description-style dark-blue-theme description-box" [innerHTML]="description">
            </span>
          </div>
        </div>
      }
      @if (isHTML && contentTemplate) {
        <ng-container
          *ngTemplateOutlet="contentTemplate; context: contentContext"
        ></ng-container>
      }
      <!-- <div *ngIf="description" class="confirmation-message">
      <span class="modal-description-style" style="margin: 1rem;">{{description}}
      </span>
    </div> -->
    </div>
    @if (!contentTemplate) {
      <div class="modal-design">
        @for (button of buttons; track button) {
          <button
            type="button"
            [ngClass]="button?.styleClass"
            class="btn me-2"
            data-dismiss="modal"
            (click)="onButtonClick(button.actionId)"
          >
            {{ button.title }}
          </button>
        }
      </div>
    }
  </div>
}

@if (isForm && isFormReady) {
  <div class="modal-content">
    @if (img) {
      <img class="icon-styling mb-2" [src]="img" aria-hidden="true" />
    }
    @if (title) {
      <div class="text-center">
        <span style="margin: 1rem" class="modal-title-style">{{ title }} </span>
        <p class="subTitle site-detail small">{{ subTitle }}</p>
      </div>
    }
    <div class="modal-body">
      <form [formGroup]="form">
        <div class="row">
          @for (field of fields; track field) {
            <div class="form-group mb-3 col-12 col-md-6">
              <span class="name-style ms-3 small">
                {{ field?.label }}
                @if (field?.isrequired) {
                  <span class="required text-danger">*</span>
                }
              </span>
              @if (field.type !== "select") {
                <input
                  [placeholder]="field?.placeholder"
                  [id]="field?.name"
                  [formControlName]="field.name"
                  [type]="field.type"
                  class="form-select form-control button-input"
                  [ngClass]="{
                    'is-invalid':
                      form.get(field.name)?.touched &&
                      form.get(field.name)?.invalid,
                  }"
                />
              }
              @if (field.type === "select") {
                <select
                  [id]="field?.name"
                  [formControlName]="field.name"
                  class="form-select form-control button-input"
                  [ngClass]="{
                    'is-invalid':
                      form.get(field.name)?.touched &&
                      form.get(field.name)?.invalid,
                  }"
                >
                  @for (option of field.options; track option) {
                    <option
                      class="text-black-50"
                      [value]="option"
                      [disabled]="option === ''"
                    >
                      {{ option === "" ? field?.label : (option | titlecase) }}
                    </option>
                  }
                </select>
              }
              @if (
                form.get(field.name)?.invalid && form.get(field.name)?.touched
              ) {
                <div class="invalid-feedback ms-2">
                  @if (form.get(field.name)?.errors?.["required"]) {
                    <span>{{ field?.label }} is required.</span>
                  }
                  @if (form.get(field.name)?.errors?.["pattern"]) {
                    <span>Invalid value.</span>
                  }
                  @if (form.get(field.name)?.errors?.["min"]) {
                    <span>{{ field?.placeholder }} must be between 100 - 100,000,000 gallons</span>
                  }
                  @if (form.get(field.name)?.errors?.["max"]) {
                    <span
                      >{{ field?.placeholder }} must be between 100 - 100,000,000 gallons</span>
                  }
                  @if (
                    field.name === "displayName" &&
                    (form.get(field.name)?.errors?.["minlength"] ||
                      form.get(field.name)?.errors?.["maxlength"])
                  ) {
                    <span>
                      {{ field?.label }} must be between 3-20 characters.
                    </span>
                  }
                  @if (
                    field.name === "displayName" &&
                    form.get(field.name)?.errors?.["customError"]
                  ) {
                    <span>
                      {{ form.get(field.name)?.errors?.["customError"] }}
                    </span>
                  }
                </div>
              }
            </div>
          }
        </div>
      </form>
    </div>
    @if (!contentTemplate) {
      <div class="modal-button">
        @for (button of buttons; track button) {
          <button
            type="button"
            [disabled]="button.actionId === 'confirm' && isForm && form.invalid"
            [ngClass]="button.styleClass"
            data-dismiss="modal"
            (click)="handleAction(button?.actionId || '')"
          >
            {{ button.title }}
          </button>
        }
      </div>
    }
  </div>
}
